import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled, { css } from 'styled-components';
import { g as getRem, a as getPadding } from './styled-utils-3f8463ca.js';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border: 1px solid ", ";\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-content: center;\n  border-radius: ", ";\n  display: inline-block;\n  font-size: ", ";\n  line-height: 1;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var baseStyles = css(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return getRem(theme.radii.sm);
}, function (_ref2) {
  var theme = _ref2.theme;
  return getRem(theme.fontSizes.xs);
}, function (_ref3) {
  var theme = _ref3.theme;
  return getPadding('px-xs', theme);
}, function (_ref4) {
  var theme = _ref4.theme;
  return getPadding('py-xxs', theme);
});
var variantStyles = css(_templateObject2(), function (_ref5) {
  var theme = _ref5.theme,
      variant = _ref5.variant;
  return theme.colors[variant][0];
}, function (_ref6) {
  var theme = _ref6.theme,
      variant = _ref6.variant;
  return theme.colors[variant][9];
}, function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant;
  return theme.colors[variant][9];
});
var StyledBadge = styled.div(_templateObject3(), baseStyles, variantStyles);

var Badge = function Badge(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      className = _ref.className;
  return React.createElement(StyledBadge, {
    variant: variant,
    className: className
  }, children);
};

Badge.defaultProps = {
  className: null,
  variant: 'grey'
};
Badge.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Badge",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "variant": {
      "defaultValue": {
        "value": "'grey'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'grey'",
          "computed": false
        }, {
          "value": "'success'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }]
      },
      "required": false,
      "description": "The color variant of the Button"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "Content of the Badge"
    }
  }
};
export default Badge;
export { Badge };